import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import { createBlacklistFilter } from 'redux-persist-transform-filter';
import storage from 'redux-persist/lib/storage';
import appReducer from '../reducers/appReducer';
import authReducer from '../../auth/reducers/authReducer';
import wizardReducer from '../../wizard/reducers/wizardReducer';
import dashboardReducer from '../../dashboard/reducers/dashboardReducer';
import usersReducer from '../../users/reducers/usersReducer';
import groupsReducer from '../../groups/reducers/groupsReducer';

const authBlacklist = createBlacklistFilter('auth', [
    'isLogginIn',
    'passwordReset.isSending',
    'passwordReset.isReseting',
    'supportConnection.fetching',
    'supportConnection.connecting'
]);

const wizardBlacklist = createBlacklistFilter('wizard', [
    'isResending', 'isActivating'
]);

const persistConfig = {
    key: 'root',
    storage,
    blacklist: ['dashboard', 'users', 'groups'],
    transforms: [authBlacklist, wizardBlacklist]
};

const rootReducer = combineReducers({
    app: appReducer,
    auth: authReducer,
    wizard: wizardReducer,
    dashboard: dashboardReducer,
    users: usersReducer,
    groups: groupsReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default persistedReducer;
